module.exports = __webpack_public_path__ + "img/Fondo-anaranjado-escritorio.5097962a.png";